import { render, staticRenderFns } from "./SelectBookMenu.vue?vue&type=template&id=5c182eaa&"
import script from "@/scripts/Bookmark/components/SelectBookMenu.js?vue&type=script&lang=js&"
export * from "@/scripts/Bookmark/components/SelectBookMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports